import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { removeSession } from 'actions/inPersonTraining/eventOverview/sessions';
import Section from 'components/PathBuilder/Sidebar/Section';
import { Button } from 'ui';

const DeleteSession = ({ event, session }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const deleteSessionApi = () => {
    // eslint-disable-next-line no-alert
    if (window.confirm(t('in_person_training.session.delete_confirmation'))) {
      setLoading(true);
      dispatch(removeSession(session))
        .then(() => {
          history.push(`/in_person_training/events/${event.id}`);
        })
        .catch(error => {
          setLoading(false);
          console.error(error);
        });
    }
  };
  return (
    <Section>
      <Button
        icon="delete"
        loading={loading}
        small
        fullWidth
        onClick={deleteSessionApi}
      >
        {t('in_person_training.session.delete')}
      </Button>
    </Section>
  );
};
const mapStateToProps = state => ({
  event: state.event,
});

export default connect(mapStateToProps)(DeleteSession);
